<template>
<div>
  <div id="app">
    <div id="nav">
      <span class="header" id="header">The Art of Connecting Students</span>
      <div class="topnav">
        <router-link to="/">Home</router-link>
        <router-link to="/about">About Us</router-link>
        <router-link to="/team">Our Team</router-link>
        <router-link to="/clubs">Clubs</router-link>
        <router-link to="/join">Join Us</router-link>
        <!-- <router-link to="/competitions">Competitions</router-link> -->
      </div>
    </div>
    <div class="content">
       <transition
        name="fade"
        mode="out-in"
      >
      <router-view/>
      </transition>
    </div>
  <br />
  <br />
    <div class="connection-badges">
      <div class="connection-badge">
        <a href="https://www.instagram.com/theartofconnectingstudents/" target="_blank">
          <img class="connection-icon" width="30" src="./assets/instagram.svg">
        </a>
      </div>
    </div>
    
  </div>
  <br />
  <br />
  <br />

  <div class="footer">
    <div class="footercontent">
      Copyright © 2021 The Art of Connecting Students - All Rights Reserved.
    </div>
  </div>

</div>
  
</template>

<script>
export default {
  mounted(){
    let header = document.getElementById("header")

    header.addEventListener('click', ()=>{
      window.scrollTo({top: 0, behavior: "smooth"});
    })
    window.onscroll = function() {myFunction()};

    var navbar = document.getElementById("nav");
    var sticky = navbar.offsetTop;

    
    function myFunction() {
      if (window.scrollY >= sticky) {
        navbar.classList.add("sticky")
      }
      if (window.scrollY == sticky) {
        navbar.classList.remove("sticky");
      }
    }
  }
}

</script>

<style>
  @import './assets/styles.css';
</style>
